<template>
  <v-item-group
    @update:modelValue="onSelected"
    v-model="selectedIndex"
    :multiple="multiple"
  >
    <v-row class="pa-0 ma-0">
      <v-col
        v-for="(type, index) in data.items"
        :key="type.id"
        cols="12"
        md="4"
        lg="4"
        sm="6"
      >
        <v-item v-slot="{ toggle }">
          <v-card
            :color="
              multiple
                ? selectedIndex.includes(index)
                  ? 'primary'
                  : ''
                : selectedIndex === index
                ? 'primary'
                : ''
            "
            class=""
            height="300"
            @click="toggle"
          >
            <v-scroll-y-transition hide-on-leave leave-absolute>
              <div
                v-if="
                  multiple
                    ? selectedIndex.includes(index)
                    : selectedIndex === index
                "
                :key="type.id"
                class="flex-grow-1 d-flex flex-column justify-center align-center white--text full-height"
              >
                <h3>
                  {{ type.name }}
                </h3>
                <v-icon class="mt-2" color="white"> mdi-check-circle </v-icon>
              </div>

              <div v-else :key="`info` + type.id" class="full-height">
                <v-card-title>
                  {{ type.name }}
                </v-card-title>

                <v-img
                  :key="type.id"
                  :src="type.img"
                  :lazy-src="type.img"
                  height="60"
                />

                <v-card-text class="type-description">
                  {{ type.description }}
                </v-card-text>
                <v-card-actions class="card-actions-bottom">
                  <v-btn
                    @click.prevent.stop="() => $emit('onDetails', type)"
                    text
                    border
                  >
                    <template #prepend>
                      <v-icon left>mdi-information</v-icon>
                    </template>

                    Read More
                  </v-btn>
                </v-card-actions>
              </div>
            </v-scroll-y-transition>
          </v-card>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>




<script>
import { AdPlacementTypeAPIInstance } from "../../../api";

export default {
  components: {},
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    modelValue: {},
  },
  emits: ["next", "onDetails", "update:modelValue"],
  data() {
    return {
      selectedIndex: this.multiple ? [] : null,
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
    };
  },
  computed: {},
  watch: {
    value(newVal) {
      if (!newVal) {
        this.selectedIndex = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { items, pagination } = await AdPlacementTypeAPIInstance.list(
        this.data.pagination
      );

      this.data.items = items;
      this.data.pagination = pagination;
    },
    onSelected(value) {
      this.selectedIndexes = value;

      if (Array.isArray(this.selectedIndexes)) {
        this.$emit(
          "update:modelValue",
          this.selectedIndexes.map((index) => this.data.items[index])
        );
      } else {
        this.$emit("update:modelValue", this.data.items[value]);
      }

      setTimeout(() => {
        this.$emit("next");
      }, 300);
    },
  },
};
</script>